import { INITIAL_PROVIDER_FORM } from '../constants/providersConstants';

/**
 * Estado del formulario a partir de un proveedor (o vacío para el alta), resolviendo provincia y
 * departamento desde el distrito guardado.
 * @param {Object|null} provider Proveedor a editar.
 * @param {{ departments: Array<Object>, districts: Array<Object> }} location Catálogos de
 *   ubicación.
 * @returns {Object} Estado inicial del formulario.
 */
export const buildProviderForm = (provider, { departments = [], districts = [] } = {}) => {
  if (!provider) return { ...INITIAL_PROVIDER_FORM };
  const district = districts.find((item) => item.uuid === provider.uuid_district);
  const department = departments.find((item) => item.uuid === district?.uuid_department);
  return Object.keys(INITIAL_PROVIDER_FORM).reduce(
    (form, key) => ({ ...form, [key]: provider[key] ?? INITIAL_PROVIDER_FORM[key] }),
    {
      ...INITIAL_PROVIDER_FORM,
      uuid_department: department?.uuid || '',
      uuid_province: department?.uuid_province || '',
    }
  );
};
